import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const CircleTickIcon = memo<ISvgProps>((props, { className }) => (
  <Svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M16.7988 32C25.6354 32 32.7988 24.8366 32.7988 16C32.7988 7.16344 25.6354 0 16.7988 0C7.96227 0 0.798828 7.16344 0.798828 16C0.798828 24.8366 7.96227 32 16.7988 32Z"
      fill="#3477EB"
    />
    <path
      d="M10.1328 16.4444L14.5773 20.8889L23.4661 12"
      stroke="white"
      strokeWidth={props.strokeWidth || 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
));

CircleTickIcon.displayName = 'CircleTickIcon';

export default CircleTickIcon;
